__turbopack_context__.v({
  "className": "_Zqsaa_className",
  "variable": "_Zqsaa_variable",
});
